import { useIsFocused } from "@react-navigation/native";
import { useLayoutEffect } from "react";
import { useStore } from "~/mobx/utils/useStore";

export function useProgressBarStep(step: number) {
  const store = useStore();
  const bookingStore = store.bookingStore;
  const isFocused = useIsFocused();

  useLayoutEffect(() => {
    if (isFocused) {
      bookingStore.setCurrentProgressBarStep(step);
    }
  }, [isFocused, bookingStore, step]);
}
